import(/* webpackMode: "eager" */ "/root/alex-booking-frontend/app/booking/page.tsx");
